module.exports = __webpack_public_path__ + "static/media/teacherWalkthrough.a7d17cbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/helpDesk/videos/teacherWalkthrough.jpg
// module id = 1903
// module chunks = 0